// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"204ba352","422":"96d2fd4f","455":"baa4427c"}[chunkId] + ".chunk.js";
};